import React, { PureComponent } from 'react';
import Icon from '@mdi/react';
import { mdiCheckboxMarkedCircleOutline, mdiCloseCircleOutline } from '@mdi/js';
import PmiLogo from '../../../../images/tmo_logos/pmi_logo.svg';
import batLogo from '../../../../images/tmo_logos/bat_logo.svg';
import itgLogo from '../../../../images/tmo_logos/itg_logo.svg';
import sntaLogo from '../../../../images/tmo_logos/snta_logo.svg';
import jtiLogo from '../../../../images/tmo_logos/jti_logo.svg';
import { Container, Photo, FooterContainer, FooterTitle, FooterText, LogoContainer,
  HeaderContainer, Logo, Infos, Title1, Title2, Count, FooterExtensionContainer, Title } from './card.styles';

const TMO = [{},
  {
    name: 'Philip Morris',
    logo: PmiLogo
  },
  {
    name: 'British American Tobacco',
    logo: batLogo
  },
  {
    name: 'Japan Imperial Tobacco',
    logo: jtiLogo
  },
  {
    name: 'Imperial Tobacco',
    logo: itgLogo
  },
  {
    name: 'SNTA',
    logo: sntaLogo
  }
];

const Header = ({ tmo, name1, count }) => (
  <HeaderContainer>
    <LogoContainer>
      <Logo src={TMO[tmo].logo} />
      <Infos>
        <Title1>{name1}</Title1>
        <Title2>{TMO[tmo].name}</Title2>
      </Infos>
    </LogoContainer>
    <Count>{count}</Count>
  </HeaderContainer>
);

const Footer = ({ text }) => (
  <FooterContainer>
    <FooterTitle>Communication:</FooterTitle>
    <FooterText>{text}</FooterText>
  </FooterContainer>
);

const Line = ({ title, valid }) => (
  <>
    <Title>{title}</Title>
    {
      valid ?
        <Icon path={mdiCheckboxMarkedCircleOutline} size={'24px'} color={'#4dd48f'}/> :
        <Icon path={mdiCloseCircleOutline} size={'24px'} color={'#ff5f73'}/>
    }
  </>
);

const FooterExtension = ({ isConform, isCorrected, isHotZone }) => (
  <FooterExtensionContainer>
    <Line title={'Conforme:'} valid={isConform}/>
    <Line title={'Corrected:'} valid={isCorrected} />
    <Line title={'Hot Zone:'} valid={isHotZone} />
  </FooterExtensionContainer>
);

class Card extends PureComponent {
  render() {
    const { tmo, name1, name2, count, image, isConform, isCorrected, isHotZone } = this.props;
    return (
      <Container>
        <Header tmo={tmo} name1={name1} count={count} />
        <Photo src={image}/>
        <Footer text={name2} />
        <FooterExtension isConform={isConform} isCorrected={isCorrected} isHotZone={isHotZone}/>
      </Container>
    );
  }
}

export default Card;
